import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import maskString from "../../utils/maskString";
import MirageLoader from "../../components/ui/pageLoader/MirageLoader";

const ForgetPasswordOtp = () => {
  const currentUrl = window.location.href;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userData = location.state;
  const { otpForgetePassword } = useSelector((state) => state.customReducer);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [timer, setTimer] = useState(0);
  const [isButtonClicked, setIsButtonClicked] = useState();

  const orgSchemeData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "I4invest",
    url: "https://i4invest.in/",
    logo: "https://i4invest.in/images/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9769699957",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: "en",
    },
  };
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const handleInputChange = (event) => {
    if (event.target.value.length > event.target.maxLength) {
      event.target.value = event.target.value.slice(0, event.target.maxLength);
    }
    setOtp(event.target.value);
  };

  const otpHandleSubmit = (event) => {
    setIsButtonClicked(true);
    event.preventDefault();
    verifyOtp("api/forget-verify-otp");
  };

  // verify otp
  const verifyOtp = async (url) => {
    let data = {
      email: null,
      phone: null,
    };
    if (/^\d{10}$/.test(otpForgetePassword.username)) {
      data = {
        email: null,
        phone: {
          otp_id: otpForgetePassword.otp_id,
          otp: otp,
        },
      };
    } else {
      data = {
        email: {
          otp_id: otpForgetePassword.otp_id,
          otp: otp,
        },
        phone: null,
      };
    }
    await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + url,
      data: data,
    })
      .then(async (response) => {
        if (response.data.status_code == 200) {
          if (
            response.data.data.email != null &&
            response.data.data.email.verify
          ) {
            dispatch({
              type: "setAuthToken",
              payload: {
                token: response.data.data.token.access,
              },
            });
            dispatch({
              type: "setForgetOtp",
              payload: {
                verified: true,
                username: otpForgetePassword.username,
                otp_id: otpForgetePassword.otp_id,
              },
            });
            navigate("/forget-password-newpassword");
          } else if (
            response.data.data.phone != null &&
            response.data.data.phone.verify
          ) {
            dispatch({
              type: "setAuthToken",
              payload: {
                token: response.data.data.token.access,
              },
            });
            dispatch({
              type: "setForgetOtp",
              payload: {
                verified: true,
                username: otpForgetePassword.username,
                otp_id: otpForgetePassword.otp_id,
              },
            });
            navigate("/forget-password-newpassword");
          }
          setIsButtonClicked(false);
        } else if (response.data.status_code == 400) {
          setOtpError("Invalid Otp");
          setIsButtonClicked(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsButtonClicked(false);
      });
  };

  // resend Otp
  const reSendOtp = async (url) => {
    setTimer(60);
    await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + url,
      data: userData?.payload,
    })
      .then(async (response) => {
        if ((response.status = 200)) {
          if (/^\d{10}$/.test(otpForgetePassword.username)) {
            dispatch({
              type: "setForgetOtp",
              payload: {
                otp_id: response.data.data.phone.otp_id,
                username: otpForgetePassword.username,
              },
            });
          } else if (
            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
              otpForgetePassword.username,
            )
          ) {
            dispatch({
              type: "setForgetOtp",
              payload: {
                otp_id: response.data.data.email.otp_id,
                username: otpForgetePassword.username,
              },
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setTimer(0);
      });
  };
  return (
    <div className="p-8 md:flex">
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>Forgot Password | I4Invest</title>
        <meta
          name="description"
          content="I4Invest offers top portfolio management software for advisors and investors. Track and manage investments with India’s best mutual fund portfolio tracker app. Call us!"
        />
        <meta
          property="og:image"
          content="https://i4invest.in/logo_i4invest-01.png"
        />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(orgSchemeData)}
        </script>
      </Helmet>
      <div className="w-full bg-[#ffffff] pt-[130px] md:pb-[80px]">
        <div className="mx-auto max-w-[1400px] px-[16px] md:px-0">
          <div className="flex items-center justify-start gap-[25px] md:gap-[45px]">
            <img
              className="w-full max-w-[35px] max-md:hidden"
              src="images/Back-Arrow-btn.png"
              onClick={() => {
                navigate("/forget-password");
              }}
              alt=""
            />
            <h2 className="font-open text-[20px] font-[700] leading-[30px] text-[#1E1E1E] md:text-[24px] md:leading-[36px]">
              Forgot Password
            </h2>
          </div>
        </div>
        <div className="mx-auto mt-4 max-w-[1235px] px-[16px] md:ml-[80px] md:px-0">
          <p className="w-full font-open text-[16px] font-[400] leading-[24px] text-[#636363] md:w-[259px]">
            Enter OTP sent to{" "}
            {userData?.payload?.email ? (
              <span className="ml-2 text-[#F2673A]">
                {userData?.payload?.email?.length > 0 &&
                  maskString(
                    userData?.payload?.email,
                    "*",
                    1,
                    Math.max(userData?.payload?.email.indexOf("@"), 1),
                  )}
              </span>
            ) : (
              <span className="text-[#F2673A]">
                {String(userData?.payload?.phone)?.length > 0 &&
                  maskString(String(userData?.payload?.phone), "*", 0, 7)}
              </span>
            )}
          </p>

          <div className="flex flex-wrap items-start justify-between pt-[40px] md:flex-nowrap">
            <div className="w-full md:w-[322px]">
              <form onSubmit={otpHandleSubmit} action="">
                <p className="font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                  Enter OTP
                </p>
                <div>
                  <input
                    className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                    type="number"
                    placeholder="Enter here"
                    value={otp}
                    onChange={handleInputChange}
                    autoComplete="off"
                    required
                    maxLength="6"
                  />
                  {otpError && <span className="error-for">{otpError}</span>}
                  <div className="flex justify-between">
                    {timer > 0 ? (
                      <p className="flex gap-1">
                        <img src="images/schedule-click.png" />
                        <span className="font-open text-[14px] font-[500] leading-[20px] text-[#B6B6B6]">
                          {timer} seconds
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                    <div
                      className={` ${
                        timer > 0 ? "opacity-[50%]" : "cursor-pointer"
                      } font-open text-[14px] font-[600] leading-[20px] text-[#B6B6B6] underline`}
                      onClick={() =>
                        timer > 0 ? false : reSendOtp("api/forget-send-otp")
                      }
                      type="button"
                    >
                      Resend
                    </div>
                  </div>
                </div>
                <button
                  className={` ${
                    otp?.length < 6 || isButtonClicked ? "opacity-[70%]" : ""
                  } mt-[50px] w-full cursor-pointer rounded-[6px] bg-[#F2673A] px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#A94829] md:px-[32px] md:py-[13px]`}
                  type="submit"
                  disabled={otp?.length < 6 || isButtonClicked}
                >
                  {isButtonClicked ? <MirageLoader /> : "VERIFY"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className=" h-fit max-md:mt-[40px] md:my-auto md:mr-[10%] md:mt-[100px]">
        <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
          Invest{" "}
          <span className="inline-block whitespace-nowrap md:block">
            With Confidence
          </span>
        </h2>
        <p className="mx-auto w-full pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
          Unlock Your Investment Potential with Precision Portfolio Management
        </p>
        <div>
          <img className="w-full" src="images/Financial-growth.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordOtp;
